module.exports = __webpack_public_path__ + "img/Bestekteksten.48374613.svg";